import React from "react";
import ReactDOM from "react-dom";
import "normalize.css";
import "./index.css";
import App from "./containers/app";

ReactDOM.render(<App />, document.getElementById("root"));
